// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import _ from 'lodash';

import HighChartGraph, { ApiHandler as HC, HighChartOptions } from 'wdna-highchart';
import { emptyData, getDateFormat } from 'wdna-components/lib/helpers/highchart';

import pressets from './pressets';

interface Props {
  update: string;
  graphInput: {
    data: any[];
  };
}

type State = unknown;

export default class GraphChart extends React.Component<Props, State> {
  public constructor(props: Props) {
    super(props);
    this.state = {
    };
  }

  public componentDidMount(): void {
    /* pass */
  }

  public shouldComponentUpdate(nextProps: Props): boolean {
    return this.props.update !== nextProps.update;
  }

  public componentWillUnmount(): void {
    /* pass */
  }

  public getOptions = (): HighChartOptions => {
    const options: HighChartOptions = _.cloneDeep(pressets.line);
    const hc: HC = new HC(options);
    const { axisX } = getDateFormat();
    hc.setXAxisFormat(axisX);

    return options;
  };

  public render(): JSX.Element {
    const { data } = this.props.graphInput;
    const options: HighChartOptions = this.getOptions();

    return (
      <div style={{ height: 'calc(60vh)' }}>
        <HighChartGraph data={data || emptyData} options={options} settings />
      </div>
    );
  }
}
